import React, { useEffect, useState } from "react";
export const useOrientation = () => {
  const [dimension, setDimension] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [orientation, setOrientation] = useState("landscape");

  useEffect(() => {
    setOrientation(
      dimension.width > dimension.height ? "landscape" : "portrait"
    );
  }, [dimension]);

  useEffect(() => {
    window.addEventListener("resize", () => {
      setDimension(
        JSON.parse(
          JSON.stringify({
            width: window.innerWidth,
            height: window.innerHeight,
          })
        )
      );
    });
  }, []);

  return [orientation, dimension];
};
